import Backbone from 'backbone';

export const GBISimilarSearchesModel = Backbone.Model.extend({
	initialize: function(options) {
		this.set('results', null);
		this._requestData = this._getDefaultRequestData(options);
	},

	_getDefaultRequestData: function(options) {
		return { query: (options && options.query) || '' };
	},

	setSearchTerm: function(term) {
		this._requestData.query = term;
	},

	fetch: function() {
		return Promise.resolve(null);
	}
});
